var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"detail-section"},[_c('h3',{staticClass:"section-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"section-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }